export enum SpecializedRolesEnum {
  PROVIDER_ADMIN = 'ProviderAdmin',
  CENTER_ADMIN = 'CenterAdmin',
  WORKER = 'Worker'
}
